import React, { Component } from 'react'

export default class DemoVideos extends Component {
    render() {
        return (
        <div className="panel panel-primary">
            <div className="panel-body" style={{padding:'10px'}}>
                <div className='row'>
            {
                this.props.listItems.map(item=>{
                    return (<div className="col-xs-6 col-md-2">
                    <span><b>{item.title}</b></span>
                    <div className="embed-responsive embed-responsive-16by9">
                        <iframe className="embed-responsive-item" width="560" height="315" 
                        src={item.link} frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="allowfullscreen"></iframe>
                    </div>
                </div>)
                })
            }
            </div>
            </div>
        </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Parent/Home/demoVideos.jsx